import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { useTranslation } from "react-i18next"

interface ConfirmationDialogProps {
  open: boolean
  contentMessage: string
  onClose: () => void
  onConfirm: () => void
}

export default function ConfirmationDialog({
  open,
  contentMessage,
  onClose,
  onConfirm,
}: ConfirmationDialogProps) {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>{t('actions.confirm')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
            {/* contentMessage 内の改行文字を処理する */}
            {contentMessage.split('\n').map((line, idx) => (
                <span key={idx}>
                    {line}
                    {idx < contentMessage.split('\n').length - 1 && <br />}
                </span>
            ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
        >
          {t('actions.ok')}
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          color="secondary"
        >
          {t('actions.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
